import { render } from "./Formation.vue?vue&type=template&id=c502e300&scoped=true"
import script from "./Formation.vue?vue&type=script&lang=js"
export * from "./Formation.vue?vue&type=script&lang=js"

import "./Formation.vue?vue&type=style&index=0&id=c502e300&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c502e300"]])

export default __exports__